import { cn } from "@/lib/tailwind";
import { StaticImport } from "next/dist/shared/lib/get-img-props";
import Image, { ImageProps } from "next/image";
import { HTMLAttributes } from "react";

interface IProps {
  src: string | StaticImport;
  title: string;
  size?: number;
  classname?: HTMLAttributes<HTMLButtonElement>["className"];
  imgProps?: Omit<ImageProps, "src" | "alt">;
}

const DEFAULT_SIZE = 24;

const Icon = ({ src, title, size, classname, imgProps }: IProps) => {
  return (
    <div
      className={cn("flex items-center justify-center ", classname)}
      style={{
        width: size ? `${size}px` : `${DEFAULT_SIZE}px`,
        height: size ? `${size}px` : `${DEFAULT_SIZE}px`,
      }}
    >
      <Image {...imgProps} src={src} alt={title} className="w-auto" width={size ?? DEFAULT_SIZE} height={size ?? DEFAULT_SIZE} />
    </div>
  );
};

export default Icon;
